<template>
<b-col class="text-right">
        <otif-button className="secondary">Cancel</otif-button>
        <otif-button className="primary" @click="save">Save</otif-button>
</b-col>
</template>

<script>

export default {

    props: ['job'],

    methods: {
        cancel() {
            this.$emit('cancel');
        },
        save() {

            this.$snotify.info('Saving', {
                timeout:  0
            });

            this.job.save()
            .then(() => {
                this.$snotify.clear();
                this.$snotify.success('Job Saved');
                this.$eventBus.$emit('job-saved');
            });
        }
    }
}
</script>
